export default __webpack_public_path__ + "static/media/card_mob.2eab7c1a.png";